import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="nested-form--dup"
export default class extends Controller {
  dup(event) {
    const srcNode = event.target.closest('fieldset')
    const newNode = srcNode.cloneNode(true);
    this._updateAttrsWithNewId(srcNode, newNode);
    this._removeIdNodes(newNode);
    srcNode.after(newNode);
  }

  _updateAttrsWithNewId(srcNode, newNode) {
    const newId = new Date().valueOf();

    const input = srcNode.querySelector("input[name]")

    const srcNamePrefix = input.name.replace(/\[\w+\]$/, "") // without attribute
    const newNamePrefix = srcNamePrefix.replace(/\[\d+\]$/, `[${newId}]`); // with new id

    const srcIdPrefix = input.id.replace(/[a-z_]+$/, "")
    const newIdPrefix = srcIdPrefix.replace(/\d+$/, newId)

    // update name and id attributes
    newNode.querySelectorAll(`[name^="${srcNamePrefix}"]`).forEach((node) => {
      node.name = node.name.replace(srcNamePrefix, newNamePrefix)
      node.id = node.id.replace(srcIdPrefix, newIdPrefix)
    })
    console.log(newNode)
  }

  _removeIdNodes(newNode) {
    newNode.querySelectorAll('[name$="[id]"]').forEach((node) => {
      node.remove();
    });
  }
}
